import { createContext } from "react";

interface GlobalActivityInfo {
  totalActivityCount: number;
  logNewActivityFor(key: string): void;
  markAllActivitiesAsRead(): void;
  updateActiveItem(key: string): void;
}

interface ActivityInfo {
  activityCount: number;
  markActivityAsRead(): void;
}

export type ActivityInfoContextValue = GlobalActivityInfo & Record<string, ActivityInfo | undefined>;

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
export const ActivityInfoContext = createContext<ActivityInfoContextValue>(undefined!);

export const activityOverflowCount = 99;
